import axios from 'axios'

const state = {
  loading: false,
  cancelling: false,
  subscribingId: null,
  currentSubscription: null,
  availableSubscriptions: [],
};

const mutations = {
  SET_LOADING(state, value) {
    state.loading = value;
  },
  SET_CANCELLING(state, value) {
    state.cancelling = value;
  },
  SET_SUBSCRIBING_ID(state, value) {
    state.subscribingId = value;
  },
  SET_CURRENT_SUBSCRIPTION(state, value) {
    state.currentSubscription = value;
  },
  SET_AVAILABLE_SUBSCRIPTIONS(state, value) {
    state.availableSubscriptions = value;
  },
};

const actions = {
    fetchCurrentSubscription({ commit }) {
      return new Promise((resolve, reject) => {
          commit('SET_LOADING', true);
          axios.get('business/subscription')
              .then(res => {
                  commit('SET_CURRENT_SUBSCRIPTION', res.data.data);
                  resolve(res.data);
              })
              .catch(error => {
                  reject(error);
              })
              .finally(() => {
                  commit('SET_LOADING', false);
              });
      });
    },
    cancelSubscription({ commit }, { pendingSubscriptionId }) {
      return new Promise((resolve, reject) => {
          commit('SET_CANCELLING', true);
          if (pendingSubscriptionId) {
              axios.post('business/subscription/cancel', pendingSubscriptionId)
                  .then((res) => {
                      commit('SET_CURRENT_SUBSCRIPTION', null);
                      resolve(res.data);
                  })
                  .then(() => {
                      resolve();
                  })
                  .catch(error => {
                      reject(error);
                  })
                  .finally(() => {
                      commit('SET_CANCELLING', false);
                  });
          } else {
              commit('SET_CANCELLING', false);
              resolve();
          }
      });
    },
    subscribeTo({ commit, dispatch, plan }) {
        return new Promise((resolve, reject) => {
            commit('SET_SUBSCRIBING_ID', plan.id);
            axios.post('/api/business/subscription/subscribe', {subscription_id: plan.id})
                .then(() => {
                    return Promise.all([
                        dispatch('fetchCurrentSubscription'),
                        dispatch('fetchAvailableSubscriptions')
                    ]);
                })
                .then(() => {
                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {
                    commit('SET_SUBSCRIBING_ID', null);
                });
        });
    }
};

const getters = {
  loading: state => state.loading,
  cancelling: state => state.cancelling,
  subscribingId: state => state.subscribingId,
  currentSubscription: state => state.currentSubscription,
  availableSubscriptions: state => state.availableSubscriptions,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
